/* eslint-disable react/react-in-jsx-scope */
import { Fragment, useMemo, useState } from 'react'
import Box from '@mui/material/Box';
import { DataGrid, 
          gridClasses,
          GridToolbar, 
          GridToolbarColumnsButton, 
          GridToolbarContainer, 
          GridToolbarDensitySelector, 
          GridToolbarExport, 
          GridToolbarFilterButton,
          gridPageCountSelector,
          gridPageSelector,
          useGridApiContext,
          useGridSelector, 
        } from '@mui/x-data-grid';
import Pagination from '@mui/material/Pagination';        
import { darken, lighten } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { blue, grey } from '@mui/material/colors';
import moment from 'moment'
import { Avatar, buttonClasses, Fab, Grid, IconButton, iconClasses, Tooltip } from '@mui/material';
import UsersActions from './UsersActions';
// import Header from '../components/Header';
import Checkbox from "@mui/material/Checkbox";
import Add from '@mui/icons-material/Add';
import { useNavigate } from 'react-router';

// const getBackgroundColor = (color, mode) =>
//   mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.6);

// const getHoverBackgroundColor = (color, mode) =>
//   mode === 'dark' ? darken(color, 0.5) : lighten(color, 0.5);


//   function CustomCheck() {
//     return (
//       <Checkbox
//         defaultChecked
//         sx={{
//           color: blue[900],
//           '&.Mui-checked': {
//             color: blue[600],
//           },
//         }}
// />
//     );
//   }





const DataTable = (props) => {
    const {column, data, rowId, setRowId} = props; 
    const [pageSize, setPageSize] = useState(props.pageSize);

    // console.log(props);
    const navigate = useNavigate();
    // console.log("reder DataTable")

  // const actionColumn = (() => [
  //       {
  //         field: 'actions',
  //         headerName: 'Actions',
  //         type: 'actions',
  //         renderCell: params => <UsersActions {...{params, rowId, setRowId}} />,
  //         // headerClassName: 'datatable-header',
  //         headerAlign: 'center',
  //         width: 200,
  //         editable: false,
  //         flex: 1,
  //     },
  //   ]
  // )

    function handleClick ()  {
      // console.log("clicked on icon!",props.link);
      navigate(props.link)
    }

  
    function CustomToolbar() {
      return (
        <GridToolbarContainer >
          <GridToolbarColumnsButton color="secondary" />
          <GridToolbarFilterButton color="secondary" />
          <GridToolbarDensitySelector color="secondary" />
          <GridToolbarExport color="secondary" 
              printOptions={{
                disableToolbarButton: true 
              }}
            
            />
          <Add color="secondary" className='hover:bg-slate-500 hover:cursor-pointer bg-slate-700 rounded-full m-1 ml-auto' 
              onClick={() => handleClick()}  />
          
        </GridToolbarContainer>
      );
    }

    function CustomPagination() {
      const apiRef = useGridApiContext();
      const page = useGridSelector(apiRef, gridPageSelector);
      const pageCount = useGridSelector(apiRef, gridPageCountSelector);

      return (
        <Pagination
          color="primary"
          count={pageCount}
          page={page + 1}
          onChange={(event, value) => apiRef.current.setPage(value - 1)}
        />
      );
    }
  
    // const dataupdate = {};
  function getObjectChanges(obj1, obj2) {
    let changes = false;
    for (const key in obj1) {
      // console.log(obj1[key],obj2[key])
        if (obj1[key] !== obj2[key]) {
          // dataupdate[key] = obj2[key];
            changes = true;
        }
    }
    if(changes==true) setRowId(obj2.id);
    // console.log(changes);
    return changes;
  }  

  return (
    <Box className=''
        sx={{ p: 1, height: '100%',
        }}
    >
        <DataGrid

            rows={data}
            columns={column}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[5,10,30,50,100]}
            checkboxSelection={false}
            // getRowId={(row) => row.userId}
            // getRowId={(row) => `row.${props.fieldrowID}`}
            disableSelectionOnClick
            headerHeight={38}
            // experimentalFeatures={{ newEditingApi: true }}
            // getCellClassName={(params) => console.log(params)}
            components={{
                  Toolbar: CustomToolbar,
                  Pagination: CustomPagination,
                // BaseCheckbox: CustomCheck,
            }}
            sx={{
                closeAfterTransition:false,
                '& .MuiDataGrid-cell:hover': {
                  color: 'primary.main',
                },
                // '& .MuiDataGrid-row:hover': {
                //   color: 'primary.main',
                //   bgcolor: '#07377f',
                // },
                [`& .${gridClasses.row}`]: {
                      bgcolor:'#82b1ff',
                    // bgcolor: (theme) =>
                    // theme.palette.mode === 'light' ? '#bdbdbd' : '#212121',
                  //  '&:hover': {
                  //     backgroundColor: "#092f6c",
                  //     // '@media (hover: none)': {
                  //     //   backgroundColor: 'transparent',
                  //     // },
                  //   },
                },
                [`& .${gridClasses.columnHeader}`] : {
                  bgcolor: '#1a237e',
                  color: '#ffff',
                  // bgcolor: (theme) =>
                  //   theme.palette.mode === 'light' ? '#e0e0e0' : grey[800],
                },
                "& .MuiDataGrid-row:hover": {
                    backgroundColor: "skyblue"
                    // color: "red"
                },
                  "& .MuiDataGrid-row.Mui-selected": {
                      bgcolor: '#0e6496',
                      color: '#ffffff',
                      '&:hover': {
                          bgcolor: '#1593c4',
                      },
                  },
                // [`& .${gridClasses.GridToolbarExport}`] : {
                //   color: (theme) =>
                //     theme.palette.mode === 'light' ? grey[200] : grey[700],
                // },
            }}
            processRowUpdate={(updatedRow, originalRow) => {
              // console.log(updatedRow);
              // console.log(originalRow);
              getObjectChanges(originalRow, updatedRow)
              return updatedRow;
              // setRowId(params.id)
            }}
            // onProcessRowUpdateError={console.log("RowUpdate Error!!!")}
            // onCellEditCommit={(params) => {
            //   console.log(params);
            //   setRowId(params.id)
            // }}
            // onCellEditStart={(params, event) => {
              //  console.log(params,event);
            // }} 
            // onCellEditStop={(params, event) => {
              // setRowId(params.id)
              //  console.log(params,event);
            // }} 
        />
    </Box>
  )
}

export default DataTable